<template>
  <div class="CategoryAccordion">
    <div class="Title" @click="toggleOpen">
      <div>{{ item.title }}</div>
      <div>
        <div v-if="isOpen" class="ArrowIcon" v-html="icons.arrowTop"></div>
        <div v-else class="ArrowIcon" v-html="icons.arrowBottom"></div>
      </div>
    </div>
    <div v-if="isOpen" class="Items">
      <div
        v-for="subItem in item.items"
        class="Item"
        :class="{selected: selectedCategory && selectedCategory.resourceId === subItem.resourceId}"
        :key="subItem.title"
        @click="$emit('onSelectCategory', subItem)"
      >
        <div v-if="selectedCategory && selectedCategory.resourceId === subItem.resourceId" class="DiamondIcon" v-html="icons.diamond"></div>
        <span>{{ subItem.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      icons: {},
      item: {},
      initialIsOpen: {
        type: Boolean,
        default: false
      },
      selectedCategory: {}
    },
    data: function(){
      return {
        isOpen: this.initialIsOpen
      }
    },
    watch: {
      initialIsOpen(newVal) {
        this.isOpen = newVal;
      }
    },
    methods: {
      toggleOpen() {
        this.isOpen = !this.isOpen;
        this.$emit('update:isOpen', this.isOpen);
      }
    }
  }
</script>